<template>
    <div>
        <div
            class="navigation-drawer-wrapper flex h-screen justify-end duration-300 z-50 p-shadow-2 top-0 left-0"
            :class="{
                closed:
                    !isNavigationOpen &&
                    store.getters.isNavigationDrawerClosable,
                absolute: store.getters.isNavigationDrawerClosable,
                relative: !store.getters.isNavigationDrawerClosable,
            }"
        >
            <div
                class="navigation-drawer flex flex-col py-4 px-8 overflow-visible bg-surface-e relative overflow-y-auto z-40"
            >
                <div class="flex justify-between items-center text-2xl mb-8">
                    <div class="flex items-center">
                        <img
                            class="w-50 h-auto"
                            alt="Clere Golf Hub"
                            src="../../assets/clere-logo-new.png"
                        />
                    </div>
                    <div
                        class="close-button"
                        v-if="store.getters.isNavigationDrawerClosable"
                    >
                        <Button
                            icon="pi pi-times"
                            class="p-button-rounded p-button-text"
                            @click="setIsNavigationOpen(false)"
                        />
                    </div>
                </div>

                <div class="space-y-6">
                    <div
                        class="flex flex-col"
                        v-for="(group, i) in links"
                        :key="i"
                    >
                        <div
                            class="flex gap-3 uppercase text-opacity-80 text-xs mb-2"
                            :class="{
                                'text-dark': !isDark,
                                'text-light': isDark,
                            }"
                        >
                            <span>{{ group.name }}</span>
                            <i
                                class="fas fa-lock pr-3 mt-0.5"
                                v-if="
                                    !group.permissions.some(
                                        (x) =>
                                            JSON.parse(
                                                store.state.accountPermissions,
                                            ).indexOf(x) !== -1,
                                    ) && !group.permissions.includes('*')
                                "
                            />
                        </div>
                        <div
                            class="select-none"
                            v-for="(link, j) in group.subLinks"
                            :key="j"
                        >
                            <div
                                class="flex items-center py-1 pl-3 h-full border-opacity-40 border-l text-white text-opacity-20 pointer-events-none duration-200"
                                v-if="
                                    JSON.parse(
                                        store.state.accountPermissions,
                                    ).indexOf(link.permission) === -1 &&
                                    link.permission !== '*' &&
                                    false
                                "
                            >
                                <i class="fas fa-lock py-2 mr-3" />
                                <span>{{ link.name }} </span>
                            </div>

                            <RouterLink
                                class="flex py-1 pl-3 h-full border-opacity-40 cursor-pointer text-opacity-50 duration-200 hover:text-opacity-100"
                                :class="{
                                    'text-opacity-90 border-l-4 border-opacity-90':
                                        isCurrentRoute(link.route),
                                    'border-l': !isCurrentRoute(link.route),
                                    'text-dark border-text-dark': !isDark,
                                    'text-light border-text-light': isDark,
                                }"
                                :to="link.route"
                                v-if="
                                    JSON.parse(
                                        store.state.accountPermissions,
                                    ).indexOf(link.permission) !== -1 ||
                                    link.permission === '*'
                                "
                                @click.native="setIsNavigationOpen(false)"
                            >
                                {{ link.name }}
                            </RouterLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="absolute bg-black bg-opacity-30 w-screen h-screen duration-200 z-40"
            :class="{
                'opacity-100':
                    isNavigationOpen &&
                    store.getters.isNavigationDrawerClosable,
                'opacity-0 pointer-events-none':
                    !isNavigationOpen ||
                    !store.getters.isNavigationDrawerClosable,
                hidden: !store.getters.isNavigationDrawerClosable,
            }"
            @click="setIsNavigationOpen(false)"
        ></div>
    </div>
</template>

<script lang="ts">
// vue
import { defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/store';

// configs
import links from '@/vue3/configs/navigationConfig';

// primevue
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Button,
    },
    props: {
        isFullScreen: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, vm) {
        // hooks
        const store = useStore();

        // properties
        const isDark = true;

        // computed
        const isMobile = computed(() => {
            return store.state.isMobile;
        });

        const isNavigationOpen = computed({
            get: () => {
                return store.state.isNavigationDrawerOpen;
            },
            set: (value: boolean) => {
                store.commit('setIsNavigationDrawerOpen', value);
            },
        });

        // methods
        const isCurrentRoute = (route: string) => {
            return vm.root.$route.fullPath === route;
        };

        const setIsNavigationOpen = (value: boolean) => {
            isNavigationOpen.value = value;
        };

        return {
            store,
            isMobile,
            isDark,
            isCurrentRoute,
            links,
            isNavigationOpen,
            setIsNavigationOpen,
        };
    },
});
</script>

<style scoped>
.navigation-drawer-wrapper,
.navigation-drawer {
    width: 250px;
    min-width: 250px;
    max-width: 250px;
}

.closed {
    width: 0px;
    min-width: 0px;
    max-width: 0px;
}

.close-button > .p-button.p-button-text {
    color: rgb(214, 214, 214);
}

.close-button > .p-button.p-button-text:enabled:hover {
    background: rgba(63, 81, 181, 0.04);
    color: white;
    border-color: transparent;
}
</style>
